/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsBuildWorkItem {
    getFixupPrototypeFunction() { return AzureDevOpsBuildWorkItem.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsBuildWorkItem>): AzureDevOpsBuildWorkItem {
        let obj = Object.assign(new AzureDevOpsBuildWorkItem(), model);
        AzureDevOpsBuildWorkItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsBuildWorkItem>): AzureDevOpsBuildWorkItem {
        if (!model) return null;
        return AzureDevOpsBuildWorkItem.newInstance(<AzureDevOpsBuildWorkItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsBuildWorkItem) {
        if (!obj) return;

        models.AzureDevOpsBuildWorkItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsBuildWorkItem): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsBuildWorkItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.workitem_id === undefined) {
            this.workitem_id = 0;
        }
    }

    url: string;

    /**
     * Azure DevOps WorkItem ID
     */
    workitem_id: number;

    /**
     * Azure DevOps WorkItem Type
     */
    type: string;

    /**
     * Azure DevOps WorkItem Type Icon URL
     */
    icon: string;

}
